import { useState, useEffect, useReducer } from 'react'
import styled from 'styled-components'
import { utils } from 'ethers'
import networks from './networks.json'
import { CHAIN_ID } from './constants'
import { getMetarunToken } from './api/contracts'
import Header from './components/Header'
import Staking from './components/Staking'

const AppContainer = styled.div`
  min-height: 100vh;
  background: #0f083a;
  background: radial-gradient(
    46.6% 93.31% at 50% 53.4%,
    #000000 0%,
    #170f47 100%
  );
`

const AppWrapper = styled.div`
  min-height: 100vh;
  background-image: url(${require(`./images/MainBackground.png`)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
`

function App() {
  const [userAddress, setUserAddress] = useState('')
  const [userBalance, setUserBalance] = useState('0.00')
  const [mrunBalance, setMrunBalance] = useState('0.00')
  const [chainId, setChainId] = useState('')

  const [forced, forceUpdate] = useReducer(x => x + 1, 0)

  function onAddressChanged(accounts) {
    setUserAddress(utils.getAddress(accounts[0]))
  }

  function onChainChanged() {
    setUserBalance('0.00')
    window.ethereum
      .request({ method: 'eth_chainId' })
      .then(chain => setChainId(chain))
  }

  useEffect(() => {
    if (chainId === networks[CHAIN_ID].params.chainId && userAddress) {
      try {
        const MetarunToken = getMetarunToken()
        MetarunToken.balanceOf(userAddress).then(res => {
          const mrun = utils.formatEther(res)
          setMrunBalance(mrun)
        })
      } catch (e) {
        console.log(e)
      }
    }
  }, [userAddress, chainId, forced])

  useEffect(() => {
    if (chainId === networks[CHAIN_ID].params.chainId && userAddress) {
      window.ethereum
        .request({ method: 'eth_getBalance', params: [userAddress, 'latest'] })
        .then(balance => {
          const num = Number(utils.formatEther(balance))
          setUserBalance(num.toFixed(2))
        })
    }
  }, [userAddress, chainId])

  useEffect(() => {
    if (userAddress) {
      window.ethereum
        .request({ method: 'eth_chainId' })
        .then(chain => setChainId(chain))
    }
  }, [userAddress])

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', onAddressChanged)
      window.ethereum.on('chainChanged', onChainChanged)
    }
    return () => {
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', onAddressChanged)
        window.ethereum.removeListener('chainChanged', onChainChanged)
      }
    }
  }, [])

  return (
    <AppContainer>
      <AppWrapper>
        <Header
          chainId={chainId}
          userAddress={userAddress}
          setUserAddress={setUserAddress}
          userBalance={userBalance}
        />
        <Staking
          userAddress={userAddress}
          chainId={chainId}
          mrunBalance={mrunBalance}
          forceUpdate={forceUpdate}
          forced={forced}
        />
      </AppWrapper>
    </AppContainer>
  )
}

export default App
